import {Product} from "./product";
import {CustomerPaymentMethod} from "./customer-payment-method";

class CreditCard {
  brand: string;
  number: string;
  constructor(creditCardData?: any) {
    this.brand = creditCardData.brand;
    this.number = creditCardData.number;
  }
}

class PaymentMethod {
  identifier: string;
  paymentConditionIdentifier: string;
  creditCard: CreditCard;
  constructor(paymentMethodData?: any) {
    if (paymentMethodData) {
      if(paymentMethodData.identifier === 'ADYEN') {
        paymentMethodData.identifier = 'CREDIT_CARD';
      }
      
      this.identifier = paymentMethodData.identifier;
      if (paymentMethodData.identifier === 'CREDIT_CARD') {
        this.paymentConditionIdentifier = paymentMethodData.paymentConditionIdentifier;
        this.creditCard = new CreditCard(paymentMethodData.creditCard);
      }
    }
  }
}
export class AutomaticRecharge {
  active: boolean;
  product: Product;
  paymentData: PaymentMethod;

  constructor(automaticRechargeData?: any) {
    this.active = automaticRechargeData.active;
    if (automaticRechargeData.product) {
      this.product = new Product(automaticRechargeData.product);
    }

    if (automaticRechargeData.paymentData) {
      this.paymentData = new PaymentMethod(automaticRechargeData.paymentData);
    }
  }
}
